var _excluded = ["hideLoader", "iconProps", "iconSize", "loadingMessage"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
//

import * as React from 'react';
import { CenterBox } from "./Box";
import { SvgLoaderSignal } from "../../svg";
export default function Loading(_ref) {
  var hideLoader = _ref.hideLoader,
    _ref$iconProps = _ref.iconProps,
    iconProps = _ref$iconProps === void 0 ? {} : _ref$iconProps,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 64 : _ref$iconSize,
    loadingMessage = _ref.loadingMessage,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CenterBox, rest, !hideLoader && /*#__PURE__*/React.createElement(SvgLoaderSignal, _extends({
    size: iconSize
  }, iconProps)), loadingMessage);
}